import { z } from 'zod';
import { createSortablePaginationSchema } from '../shared/index.js';
import { MeetingBodySeatTermApplicationStatus, } from '../index.js';
export const applicantDirectoryQueryParamsSchema = createSortablePaginationSchema([
    'firstName',
    'lastName',
    'submittedAt',
]).extend({
    quickSearch: z.string().optional(),
    status: z.enum(Object.values(MeetingBodySeatTermApplicationStatus)).optional(),
    meetingBodyId: z.number().int().positive().optional(),
    meetingBodySeatId: z.number().int().positive().optional(),
    isGovSubmitted: z.boolean().optional(),
    submittedDateFrom: z.coerce.date().optional(),
    submittedDateTo: z.coerce.date().optional(),
});
